// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    organizationId: z.string().min(1).max(21),
    organizationRoleId: z.string().min(1).max(21),
});
const guard = z.object({
    tenantId: z.string().max(21),
    organizationId: z.string().min(1).max(21),
    organizationRoleId: z.string().min(1).max(21),
});
export const OrganizationJitRoles = Object.freeze({
    table: 'organization_jit_roles',
    tableSingular: 'organization_jit_role',
    fields: {
        tenantId: 'tenant_id',
        organizationId: 'organization_id',
        organizationRoleId: 'organization_role_id',
    },
    fieldKeys: [
        'tenantId',
        'organizationId',
        'organizationRoleId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
